import { combineReducers } from 'redux';
import ActionReducers from './ActionReducers';
import authTokenReducer from './authTokenReducer';
import userConfigReducer from './userConfigReducer';
export default combineReducers({
    peoples:ActionReducers,
    loginUrl:authTokenReducer,
    userConfigs:userConfigReducer,
})